<template>
    <div v-if="row" :class="applyClasses(column.classes, row) || ''">
        <!-- Empty Cell Display -->
        <span v-if="column.emptyDisplay && isEmpty(row, column)">
            <span class="badge badge-secondary">{{ column.emptyDisplay }}</span>
        </span>
        <!-- Link Display -->
        <span v-else-if="column.link && column.link(row)">
            <router-link :to="column.link(row)">
                <template v-if="column.display">{{ column.display(row) }}</template>
                <template v-else>{{ getProp(column.key, row) }}</template>
            </router-link>
        </span>
        <!-- Glyph Display -->
        <span v-else-if="column.type === 'glyph'" class="align-middle icon" :class="column.display(row)"></span>
        <!-- List Display -->
        <span v-else-if="column.type === 'list'">
            <span v-if="column.clickable">
                <a
                    class="badge mr-1"
                    v-for="(element, index) in listDisplayed"
                    :key="index"
                    :class="column.listClass(element, row)"
                    @click="addToSearch(column.display(element))"
                >
                    {{ column.display(element) }}
                </a>
            </span>
            <span v-else>
                <span
                    class="badge mr-1"
                    v-for="(element, index) in listDisplayed"
                    :key="index"
                    :class="column.listClass(element, row)"
                >
                    {{ column.display(element) }}
                </span>
            </span>
            <a class="badge badge-gray" v-show="showExpandList" @click="expandList()">...</a>
        </span>
        <!-- Custom Display -->
        <span v-else-if="column.display" >{{ column.display(row) }}</span>
        <!-- Key Display -->
        <span v-else>{{ getProp(column.key, row) }}</span>
        <!-- Badges -->
        <span v-if="column.badges" class="ml-1">
            <span v-for="(badge, index) in column.badges(row)" :key="index" class="badge badge-gray mr-1">{{
                badge
            }}</span>
        </span>
    </div>
</template>

<script>
import Utilities from "@/assets/js/utilities.js"

export default {
    name: "BaseTableCell",
    props: {
        row: {
            type: Object,
            required: true,
        },
        column: {
            type: Object,
            required: true,
        },
        maxItemsPerColumn: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            listIsExpanded: false,
        }
    },
    computed: {
        listItemsExceedMax() {
            if (this.column.type !== "list") {
                return false
            }
            return this.column.elements(this.row).length > this.maxItemsPerColumn
        },
        showExpandList() {
            return this.listItemsExceedMax && !this.listIsExpanded
        },
        listDisplayed() {
            if (this.column.type !== "list") {
                return []
            }
            if (this.listItemsExceedMax && !this.listIsExpanded) {
                return this.column.elements(this.row).slice(0, this.maxItemsPerColumn)
            }
            return this.column.elements(this.row)
        },
    },
    methods: {
        // Check if a column is empty for data in a given row.
        isEmpty(row, column) {
            if (column.display && !column.type == "list") {
                return !column.display(row)
            } else {
                return !this.getProp(column.key, row)
            }
        },
        // Get a nested property of an object separated by dots, return null if not found.
        getProp(key, row) {
            return Utilities.getNestedProperty(key, row)
        },
        // Add a search string for a given column name and search value to the searchbar.
        addToSearch(text) {
            this.$emit("addToSearch", text)
        },
        expandList() {
            this.listIsExpanded = true
        },
        applyClasses(classes, row) {
            if (!classes) { return "" }
            if (typeof(classes) == "function") {
                return classes(row)
            }
            return classes
        },
    },
}
</script>
